import { render, staticRenderFns } from "./started.vue?vue&type=template&id=3c1ba4f4&"
import script from "./started.vue?vue&type=script&lang=js&"
export * from "./started.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports